module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro2--swiss-70d9917036d2efc0a95788bcf102f73e.webp";